import React, { useState } from "react";
import SearchLocation from "./SearchLocation";
import LocationIcon from "../../../../../assets/icons/location.svg";
import GoogleMapLocation from "./GoogleMapLocation";
import { useDispatch, useSelector } from "react-redux";
import { stepsActions } from "../../../../../store/steps-slice";

const Location = () => {
  const [toggleBtn, setToggleBtn] = useState(false);

  const dispatch = useDispatch();

  const range = useSelector((state) => state.steps.radius);

  function handleLifeClick() {
    setToggleBtn(false);
  }

  function handleDailyClick() {
    setToggleBtn(true);
  }

  function handleSlideChange(event) {
    dispatch(stepsActions.handleSetRadius(+event.target.value));
  }

  const position = (range * 100) / 30;

  return (
    <div className="Budget-date">
      <div className="cs3-locationType">
        <p className="cs3-title">Location type</p>
        <div className="cs3-toggleBtn">
          <p className={`${toggleBtn ? "cs3-toggleBtn-inactive" : "cs3-toggleBtn-active"}`} onClick={handleLifeClick}>
            Area
          </p>
          <p className={`${!toggleBtn ? "cs3-toggleBtn-inactive" : "cs3-toggleBtn-active"}`} onClick={handleDailyClick}>
            Radius
          </p>
        </div>
      </div>
      <div className="cs3-locationSearch">
        <p className="cs3-title">Your target location</p>
        <div className="location">
          <SearchLocation />
          <img className="locationIcon" src={LocationIcon} alt="location-icon" />
        </div>
      </div>
      <GoogleMapLocation />
      {toggleBtn && (
        <div className="cs3-locationRadius">
          <div className="cBudget-heading">
            <p className="cs3-title">Select target radius</p>
          </div>
          <div className="range-budget">
            <input type="range" min="1" max="30" className="rangeSlide" onChange={handleSlideChange} value={range} />
            <div className="budgetRange">
              <p className="startingRange">1</p>
              <p className="endingRange">30</p>
            </div>
            <div className="selected-rangeSlide" style={{ left: `${position}%` }}>
              {range}Km
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Location;
